import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideDialog } from '../../../base/dialog/actions';
import PoojaStepsPanel from '../../../chat/components/web/PoojaStepsPanel';
export default function PoojaStepsDialog({ onClose }) {
    const dispatch = useDispatch();
    // Get the 360 video URL from config
    const { local360VideoId } = useSelector((state) => state['features/base/config'] || {});
    // State for responsive layout
    const [isLandscape, setIsLandscape] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    // Detect mobile device and landscape orientation
    useEffect(() => {
        const checkDeviceAndOrientation = () => {
            const userAgent = navigator.userAgent;
            const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
            const isLandscapeOrientation = window.innerWidth > window.innerHeight;
            setIsMobile(isMobileDevice);
            setIsLandscape(isLandscapeOrientation);
        };
        // Initial check
        checkDeviceAndOrientation();
        // Listen for orientation changes
        window.addEventListener('resize', checkDeviceAndOrientation);
        window.addEventListener('orientationchange', checkDeviceAndOrientation);
        return () => {
            window.removeEventListener('resize', checkDeviceAndOrientation);
            window.removeEventListener('orientationchange', checkDeviceAndOrientation);
        };
    }, []);
    const handleClose = () => {
        dispatch(hideDialog(PoojaStepsDialog));
    };
    // Determine layout based on device and orientation
    const shouldUseSplitLayout = isMobile && isLandscape;
    return (React.createElement("div", { style: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 10000
        } }, shouldUseSplitLayout ? (
    // Landscape Mobile Layout: 50-50 Split
    React.createElement("div", { style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'row',
            overflow: 'hidden',
            zIndex: 10001
        } },
        React.createElement("button", { onClick: handleClose, style: {
                position: 'absolute',
                top: '12px',
                right: '12px',
                background: 'rgba(0, 0, 0, 0.6)',
                border: 'none',
                fontSize: '1.2rem',
                cursor: 'pointer',
                color: 'white',
                padding: '6px 10px',
                borderRadius: '4px',
                zIndex: 10002,
                fontWeight: 'bold',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }, title: "Close" }, "\u00D7"),
        React.createElement("div", { style: {
                width: '50%',
                height: '100%',
                backgroundColor: '#f8f9fa',
                borderRight: '2px solid #FF7B00',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            } },
            React.createElement("div", { style: {
                    flex: 1,
                    overflow: 'auto',
                    padding: '8px'
                } },
                React.createElement(PoojaStepsPanel, null))),
        React.createElement("div", { style: {
                width: '50%',
                height: '100%',
                backgroundColor: '#000',
                position: 'relative'
            } },
            React.createElement("div", { style: {
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    zIndex: 10003
                } }, "Live 360\u00B0 View"),
            React.createElement("iframe", { src: local360VideoId || "https://live.durlabhdarshan.com/aframe/index.html", style: {
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    borderRadius: '0'
                }, title: "Live 360 View", allow: "camera; microphone; autoplay; fullscreen", allowFullScreen: true })))) : (
    // Default Layout: Side Panel (Desktop/Portrait Mobile)
    React.createElement("div", { style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '400px',
            height: '100vh',
            backgroundColor: 'white',
            boxShadow: '2px 0 10px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            zIndex: 10001
        } },
        React.createElement("button", { onClick: handleClose, style: {
                position: 'absolute',
                top: '12px',
                right: '12px',
                background: 'rgba(0, 0, 0, 0.6)',
                border: 'none',
                fontSize: '1.2rem',
                cursor: 'pointer',
                color: 'white',
                padding: '6px 10px',
                borderRadius: '4px',
                zIndex: 10002,
                fontWeight: 'bold',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }, title: "Close" }, "\u00D7"),
        React.createElement("div", { style: {
                height: '30vh',
                width: '100%',
                backgroundColor: '#000',
                borderBottom: '2px solid #FF7B00',
                position: 'relative'
            } },
            React.createElement("iframe", { src: local360VideoId || "https://live.durlabhdarshan.com/aframe/index.html", style: {
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    borderRadius: '0'
                }, title: "Live 360 View", allow: "camera; microphone; autoplay; fullscreen", allowFullScreen: true })),
        React.createElement("div", { style: {
                flex: 1,
                overflow: 'hidden',
                height: '70vh'
            } },
            React.createElement(PoojaStepsPanel, null))))));
}
